import axios from 'axios';
import { ApplicantDisabilities, ApplicantInfo, DisabilityDeletionPayload } from './types';
const baseApiUrl = 'services/customerservice/api/tls/forms';

export default class SpecialNeedsService {
  public getApplicantsInfo(client: string, issuer: string, formGroupId: number): Promise<ApplicantInfo[]> {
    return axios
      .get(`${baseApiUrl}/getApplicantNames/${client}/${issuer}/${formGroupId}`)
      .then(res => res.data)
      .catch(err => err);
  }

  public getApplicantsDisabilities(client: string, issuer: string, formGroupId: number): Promise<ApplicantDisabilities> {
    return axios
      .get(`${baseApiUrl}/getTlsFlag/${client}/${issuer}/${formGroupId}`)
      .then(res => res.data)
      .catch(err => err);
  }

  public postApplicantsDisabilities(
    client: string,
    issuer: string,
    { fIds, ff_flag, comment }: { fIds: string; ff_flag: string; comment: string }
  ): Promise<void> {
    return axios.post(`${baseApiUrl}/createTlsFlag/${client}/${issuer}`, null, {
      params: { fIds, ff_flag, comment }
    });
  }

  public deleteApplicantDisability(client: string, issuer: string, { fIds, ff_flag }: DisabilityDeletionPayload): Promise<void> {
    return axios.delete(`${baseApiUrl}/deleteTlsFlag/${client}/${issuer}`, {
      params: { fIds, ff_flag }
    });
  }
}
